module.exports = __webpack_public_path__ + "img/h1.d8441812.jpg";